import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchBarDataService {
  private _searchBarData: ReplaySubject<ISearchBarData> = new ReplaySubject();
  private searchBarData$: Observable<ISearchBarData> = this._searchBarData.asObservable();
  constructor() {}
  setSearchData(data: ISearchBarData) {
    this._searchBarData.next(data);
  }
  getSearchData() {
    return this.searchBarData$;
  }
}

export interface ISearchBarData {
  destination: string | null;
  // adults: number | null;
  // children: number | null;
  // child_ages_list: string[] | null;
  rooms: number | null;
  check_in: string | null;
  check_out: string | null;
  at_checkin?: string | null;
  currency: string | null;
  country_code: string | null;
  lat: number;
  lon: number;
  place_id: string;
  // geo_type: string;
  // is_with_driver: boolean;
  rental_type: string;
  rent_by?: string;
  at_airport_name?: string;
  at_searchText?: string;
  at_iata_code?: string;
  at_place_id?: string;
  at_pickup_date?: string | null;
  at_direction?: number;
  at_pickup_time?: number;
}
